import marked from 'marked';
import {DefaultSettings} from "../../../../settings/settings-util";
import {Store} from "redux";
import {AlmeState} from "../../../../wireup/AlmeState";
import DisplayLinksRenderer from "../../../message-renderer-display-links/src/message-renderer-display-links";
import {AlmeResponseV5} from "@alme/types/response/AlmeResponse";


export default class MarkdownUtility
{

    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    _displayLinksRenderer: DisplayLinksRenderer;


    //#region Public Interface

    constructor(settings: DefaultSettings, displayLinksRenderer: DisplayLinksRenderer)
    {
        this._displayLinksRenderer = displayLinksRenderer;
        this._settings = settings;
    }

    initialize(store: Store<AlmeState>): void
    {
        this._store = store;
    }

    convertResponse(response: AlmeResponseV5, text: string): AlmeResponseV5
    {
        const steps =
        [
            this.escapeInlineLink.bind(this),
            this.unescapeHTML.bind(this),
            this.markUp.bind(this),
            this.trim.bind(this),
        ];

        const processedText = steps.reduce((inText, step) =>
        {
            const outText = step.call(this, inText);

            if (outText !== inText && process.env.markdown_console_logging_enabled)
            {
                console.log(`Markup step "${step.name}" changed text from:\n${inText}\n\tto:\n${outText}`);
            }

            return outText;
        }, text);

        const extensionData = { ...response.extensionData, postMarkdownHtml: processedText };

        return { ...response, extensionData: extensionData };
    }

    //#endregion



    //#region Markdown Step Methods

    escapeInlineLink(str: string): string
    {
        //ABT-304
        //escape link; will render once markdown lib is done
        const inlineLinkPattern = /\[([^\][]*)]\((?:(\d{1,2}),)?(\d{1,2})?\)/ig;

        return str.replace(inlineLinkPattern, '\\$&');
    }

    unescapeHTML(str: string): string
    {
        return str
            .replace(/&quot;/g, '"')
            .replace(/&#39;/g, "'")
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&amp;/g, '&');
    }

    markUp(inText: string): string
    {
        return this.unescapeHTML(marked(inText));
    }

    trim(inText: string): string
    {
        return inText.trim();
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/response-handler-markdown/src/utils/markdown-utility.ts